var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-modal',{ref:"modal",attrs:{"title":'Fee Selection',"size-class":'modal-lg'}},[_c('fee-selection',{ref:"feeSelection",attrs:{"fee-selection-instance":_vm.feeSelectionInstance},on:{"onFeeSelected":_vm.feeSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }